import React, { useEffect } from 'react';
import { AmplifyAuthenticator,AmplifySignIn, AmplifySignUp} from '@aws-amplify/ui-react';
//import MemberLogin from './MemberLogin';
import { onAuthUIStateChange } from '@aws-amplify/ui-components';
import './App.css';


const AmplifySignCom = () => {
    useEffect(() => {
        const unsubscribe = onAuthUIStateChange((nextAuthState) => {
            console.log('Auth State Changed:', nextAuthState);
            if (nextAuthState === 'signup' && document.querySelector("#root > div > amplify-authenticator > div > amplify-sign-up")==null) {
                setTimeout(() => {
                    document.querySelector("#root > div > amplify-authenticator > div > amplify-sign-up").removeAttribute('hidden');
                        document.querySelector("#root > div > amplify-authenticator > div > amplify-sign-in").setAttribute('hidden', '');
                }, 500);
            }else if(document.querySelector("#root > div > amplify-authenticator > div > amplify-sign-up")!=null && document.querySelector("#root > div > amplify-authenticator > div > amplify-sign-in")!=null){
                    if (nextAuthState === 'signup') {
                        document.querySelector("#root > div > amplify-authenticator > div > amplify-sign-up").removeAttribute('hidden');
                        document.querySelector("#root > div > amplify-authenticator > div > amplify-sign-in").setAttribute('hidden', '');
                    }else if (nextAuthState === 'signin') { 
                        document.querySelector("#root > div > amplify-authenticator > div > amplify-sign-up").setAttribute('hidden', '');
                        document.querySelector("#root > div > amplify-authenticator > div > amplify-sign-in").removeAttribute('hidden');
                    }
                }
         
        });

        return () => unsubscribe();
    }, []);
    const formFields = [
        {
            type: 'username',
            required: true,
        },
        {
          type: 'password',
         
          fieldId:"amplifyPassword",
          required: true,
        },
      ] 
    const onAzureLogin = () => {
        window.location.href = "https://login.microsoftonline.com/0159e9d0-09a0-4edf-96ba-a3deea363c28/oauth2/v2.0/authorize?client_id=bd8d69f5-f081-4c51-82f2-d16c86643b76&response_type=token&redirect_uri=https://cbredata.com&scope=openid&response_mode=fragment&state=12345&nonce=678910";
    }
    return (
       
        <AmplifyAuthenticator >
           <AmplifySignUp slot="sign-up" formFields={formFields} >
            <div slot="header-subtitle">  </div>
           </AmplifySignUp>
            <AmplifySignIn slot="sign-in" >
                <div slot="federated-buttons" className="member-login-container">
                    <h4 className="login-button-title">CBRE社員は、緑のボタンでログイン可能</h4>
                    <h6>SSO login for CBRE Employees: Please click the button below.</h6>
                    <div className="login-button-container">
                        <button className="login-button-style" onClick={() => onAzureLogin()}>ログイン Login</button>
                    </div>
                    
                </div>
            </AmplifySignIn>
        </AmplifyAuthenticator>
     
    )
}

export default AmplifySignCom;